import { Injectable } from "@angular/core";
import { IAppState } from "@edp-store/state/app.state";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { EMPTY } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";
import { ESupportProjectsActions } from "@edp-store/actions/support-projects.action";
import { SupportProjectsService } from "@edp-services/support-projects.service";
import { ShowLoader, ELayoutActions } from "@edp-store/actions/layout.actions";
import { GoogleAnalyticsService } from "@edp-services/google-analytics.service";
import { EEdpeActions } from "@edp-store/actions/edpe.actions";
import { Projects } from "@edp-models/support-projects.model";

@Injectable()
export class SupportProjectEffects {
    loadDonations$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ESupportProjectsActions.LoadDonation),
            switchMap(() => {
                this.store.dispatch(new ShowLoader(true));
                return this.supportProjectsService.getDonation().pipe(
                    switchMap((response: Projects) => {
                        const supportProjects = {...response.projects.filter(proj => proj.type === "normal")};
                        const gasCompensationProjects = {...response.projects.filter(proj => proj.type === "gascompensation")};

                        return [
                            { type: ESupportProjectsActions.SaveDonation, payload: supportProjects[0] },
                            { type: ESupportProjectsActions.SetGasCompensation, payload: gasCompensationProjects[0] },
                            { type: ELayoutActions.ShowLoader, payload: false },
                        ];
                    }),
                    catchError(() => EMPTY)
                );
            })
        )
    );

    voteDonation$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ESupportProjectsActions.VoteDonation),
            switchMap((args: any) => {
                this.store.dispatch(new ShowLoader(true));
                return this.supportProjectsService.voteDonation(args.payload).pipe(
                    switchMap(() => {
                        this.googleAnalyticsService.datalayerEvent("PLANET_SUPPORT_PROJECTS_VOTE");
                        return [
                            { type: ESupportProjectsActions.LoadDonation },
                            { type: EEdpeActions.GetDashboardSections },
                            { type: ELayoutActions.ShowLoader, payload: false }
                        ];
                    }),
                    catchError(() => EMPTY)
                );
            })
        )
    );

    constructor(
        private actions$: Actions,
        private supportProjectsService: SupportProjectsService,
        private store: Store<IAppState>,
        private googleAnalyticsService: GoogleAnalyticsService) {}
}
